import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PaymentDetailsCss as useStyles } from './OpeningDetailsSideBarCss';
import RightSideBar from '../RightSideBar/RightSideBar';
import * as logger from '../../../logger';
import {
    CardContent,
    CardHeader,
    Card,
    Grid,
    ListItem,
    List,
    Drawer,
    Button,
    Dialog,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import { SideBarDialogContent, SideBarDialogTitle, SideBarDialogActions } from '../Dialog/Dialog';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PendingIcon } from '../../../components/icons';
import { deleteSingleDriverTransaction, fetchSingleDriverTransaction, driverAdditionType, driverDeductionType, fetchDriverOnlineTransaction } from '../../../store/actions/vehicleActionCreator';
import { updateChatView } from "../../../store/actions/userActionCreators";
import { numberFormat, getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import AddEditOpeningBalanceParty from '../../pages/Parties/AddEditOpeningBalanceParty';
import { deletePartyOpeningBalance,getPartyDetails } from '../../../store/actions/partiesActionCreator';
const OpeningBalanceDetailsSideBar = ({ user,parties,dispatchGetPartyDetails, vehicle, rightSideBarOpen, onClose, onDelete, selectedRow, dispatchChatView, dispatchFetchSingleDriverTransaction, dispatchDeleteSingleTransaction, dispatchFetchSingleDriverOnlineTransaction }) => {

    const [dialogOpen, setDialogOpen] = useState(rightSideBarOpen);
    const [singleTransactInfo, setSingleTransactInfo] = useState({});
    const [editPartyOBDialog, setEditPartyOBDialog] = useState(false);
    const [type, setType] = useState("");
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [recall, setRecall] = useState(false);

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let driverIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";
    const classes = useStyles();

    useEffect(() => {

        dispatchChatView(false);

        if (selectedRow && selectedRow.is_broker_enabled) {


        } else {
            
        }

    }, [rightSideBarOpen, recall]);
    const getCustomer = ()=>{
        dispatchGetPartyDetails(parties && parties.details && parties.details.customerId?parties.details.customerId:null,()=>{

        },()=>{
    
        })
    }
    useEffect(() => {

        if (selectedRow && selectedRow.is_broker_enabled) {
           
        } else {
           
        }
    }, [vehicle.singleDriverTransaction, vehicle.singleDriverTransactionOnline]);

    const handleClose = () => {
        getCustomer()
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const handleEditTransact = () => {
        setEditPartyOBDialog(true);
    }

    const handleDeleteTransact = () => {
        setDeleteDialog(true);
    }

    const handleBalanceClose = () => {
        setEditPartyOBDialog(false);
    }

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
    }

    const onDeleteTransaction = () => {
        dispatchDeleteSingleTransaction(selectedRow.openingBalanceId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single driver Component Dweb", "Delete transaction successfull");
                    setDeleteDialog(false);
                    handleClose()
                }
            },
            () => {
                logger.log("Single driver Component Dweb", "Delete transaction failed");
            }
        );
    }

    const handleConfirm = () => {
        setEditPartyOBDialog(false);
        handleClose()
        //setRecall(!recall);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >

                <SideBarDialogTitle id={"right-sidebar-for-opening-Balance-details"} siderBarType={'openingBalance'} onClose={handleClose} className={classes.dialogTitleV1}>
                    <div className={classes.divTitleContainer}>
                        <div className={classes.divTitle}>
                            Opening Balance
                        </div>
                        {selectedRow && !selectedRow.is_broker_enabled &&
                            <div className={classes.divAlign}>
                                <div className={classes.mrV1}>
                                    <IconButton className={classes.editButton} onClick={() => handleEditTransact()}>
                                        <EditIcon className={classes.editIcon} />
                                    </IconButton>
                                </div>
                                <div>
                                    <IconButton className={classes.deleteButton} onClick={() => handleDeleteTransact()}>
                                        <DeleteIcon className={classes.deleteIcon} />
                                    </IconButton>
                                </div>
                            </div>
                        }
                    </div>
                </SideBarDialogTitle>
                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Card className={classes.cardV1}>
                        <CardContent className={classes.cardContent} >

                            {/* ********************************* 1st Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Opening Balance Date</div>
                                    <div className={classes.textV1}>{selectedRow && selectedRow.startTime ? getMilliDatePickerDateInStringDDMMMYYYY(selectedRow.startTime) : "--"}</div>
                                </Grid>
                                <Grid item>
                                    <div className={classes.titleV2}>Amount</div>
                                    <div className={classes.textV3}>{numberFormat(selectedRow && selectedRow.amount ? selectedRow.amount : 0)}</div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                </SideBarDialogContent>
                <SideBarDialogActions className={classes.sideBarActions} >
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                        Close
                    </Button>
                </SideBarDialogActions>

            </Drawer>

            {/* **************************************** Transaction Delete Dialog. **************************************** */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteDialog} onClose={handleDeleteDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV25}> Delete Opening Balance</div>
                    <div className={classes.mtV5}>Do you want to delete opening balance for this party?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteTransaction}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>

            {editPartyOBDialog && <AddEditOpeningBalanceParty 
                open={editPartyOBDialog}  
                onClose={handleBalanceClose} 
                onSave={handleConfirm}
                defaultId={selectedRow && selectedRow.openingBalanceId?selectedRow.openingBalanceId:null}
                defaultOpeningBalance={selectedRow && selectedRow.amount?selectedRow.amount:null}
                defaultOpeningBalanceDate={selectedRow && selectedRow.date?selectedRow.date:null}
                startOpeningBalanceDate={parties && parties.details && parties.details.defaultOpeningBalanceDate?parties.details.defaultOpeningBalanceDate:null}
            />}
        </>
    )
}

export const mapStateToProps = (state) => (state);
export const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchFetchSingleDriverTransaction: (id, onSuccess, onFailure) => {
        dispatch(fetchSingleDriverTransaction(id, onSuccess, onFailure))
    },
    dispatchDeleteSingleTransaction: (id, onSuccess, onFailure) => {
        dispatch(deletePartyOpeningBalance(id,null, onSuccess, onFailure))
    },
    dispatchFetchSingleDriverOnlineTransaction: (id, onSuccess, onFailure) => {
        dispatch(fetchDriverOnlineTransaction(id, onSuccess, onFailure))
    },
    dispatchGetPartyDetails: (id, onSuccess, onFailure) => {
        dispatch(getPartyDetails(id, onSuccess, onFailure))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(OpeningBalanceDetailsSideBar);